import { postData } from "@/__main__/get-data.mjs";
import { removeActiveSession } from "@/feature-auth/fetches/api.mjs";
import ActiveSessionModel from "@/feature-auth/models/active-session-model.mjs";
import getBearerToken from "@/feature-auth/utils/get-auth-request-header.mjs";
import { devError } from "@/util/dev.mjs";

export async function removeActiveSessionData(sessionId) {
  let bearerToken, error;

  try {
    bearerToken = await getBearerToken();

    if (!bearerToken) {
      devError("FAILED TO REMOVE ACTIVE SESSION - no bearer token!", error);
      return;
    }

    return await postData(
      removeActiveSession(sessionId),
      ActiveSessionModel,
      undefined,
      { headers: { Authorization: bearerToken } },
    );
  } catch (e) {
    devError("FAILED TO REMOVE ACTIVE SESSION", e);
  }
}
